import { isObject } from "lodash";
import SocketWorker from "./SocketWorker";

/**
 * Abre (ou reaproveita) o socket da empresa.
 *
 * Aceita os DOIS formatos que os chamadores usam hoje:
 *
 *   socketConnection({ user: { companyId, id } })   // hooks/useAuth
 *   socketConnection({ companyId, userId })         // pages/Chat, ChatPopover
 *
 * Até aqui só o primeiro era lido, e o segundo produzia `companyId: undefined`.
 * Como o `SocketWorker` é singleton e fixa o namespace na PRIMEIRA construção
 * (`io(BACKEND_URL + "/" + companyId)`), bastava o ChatPopover — que fica na
 * navbar, sempre montada — ganhar a corrida para o socket inteiro conectar em
 * `/undefined`. O backend emite em `io.of(companyId)`, então NENHUM evento da
 * empresa chegava: a lista de tickets só atualizava ao recarregar a página, e o
 * defeito era intermitente porque dependia de quem montava primeiro.
 */
export function socketConnection(params) {
  if (!isObject(params)) return SocketWorker();

  const companyId = params?.user?.companyId ?? params?.companyId;
  const userId = params?.user?.id ?? params?.userId;

  return SocketWorker(companyId, userId);
}

export default socketConnection;
